// START Open Requre.JS wrapper
define([
	'jquery',
	'cms.signupform',
	'foundation.dropdown',
	'handlebars-core',
	'shared.main.screen',
	'foundation.util.keyboard'
], function(util,signupform,foundationdropdown,HBCore,screenSize) {
// END Open Require.JS wrapper


/****
 * Global CMS Footer
 *
 * Expands and collapses columns for accordion display on small screens
 * Loads region-selector dropdown on-demand
 ***/

	var PLUGIN_IDENTIFIER = "footer";
	var footer = function( element, options ) {
		this.element = $(element);
		this.options = options;
		this.data = {};
		
		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <footer class='footer' data-footer-options='{"message":"Goodbye World!"}'></section>
		this.metadata = $(this.element).data('footer-options');

	};

	footer.prototype = {
		defaults: {
			columnContent: ".column-content",
			columnHeader: ".footer_col .heading",
			regionSelector: ".footer-localize",
			regionSelectorButton: "#footer-region-button",
			regionSelectorDropdown: "#footer-region-dropdown",
			template: "html.cms.region-selector-list",

		},

		/**
		 * Initialize plugin
		 **/
		init : function() {
			console.log('Initializing footer component.');
			
			// Merge the various way of providing options
			this.config = $.extend( {},
				this.defaults,
				this.options,
				this.metadata
			);

			var self = this; // Avoid namespace conflicts with "this"

			self.$footerContent = $(self.element).find('.footer-content > div');
			self.$columnContent = self.$footerContent.find(self.config.columnContent);
			self.$columnHeaders = self.$footerContent.find(self.config.columnHeader);
			self.$regionSelector = $(this.element).find(self.config.regionSelector);
			self.$regionSelectorButton = self.$regionSelector.find(self.config.regionSelectorButton);
			self.$regionSelectorDropdown = self.$regionSelector.find(self.config.regionSelectorDropdown);

			self._build();
			self._events();

			// Initialize the subscribe form
			$(this.element).find('form.signup').signupForm();

		    // Load region selector if enabled in AEM
		    if(self.$regionSelectorButton.length > 0) {
				self._loadRegionSelector();
			}

			return self; // Allow chaining
		},

		/**
		 * Initial DOM modifications
		 **/
		_build : function() {
			var self = this;
			if (screenSize.size() === "small") {
			   self._collapseAllMenus();
			   self.bindMobileEvents();
			}else{
				self._expandAllMenus();
				self.unbindMobileEvents();
			}
		},

		/**
		 * Initialize all events to be loaded once in the _init();
		 **/

		_events : function(){
			var self = this;

			// Trigger the _build() function in the resize window event
			$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
				self._build();
			});

			// Add modal size class to the footer modal
            var $modal = $('#footerLinkModal');
            self.$columnContent.find('a[data-open][data-modal-size]').on('click', function(){
            	var $link = $(this);
                var size = $link.data('modalSize');
                $modal.attr('class', 'reveal ' + size);
            });

			$(self.element).find('.anchor-top').on('click.back-to-top', function (event) {
				event.preventDefault();
				window.scrollTo(0,0);
				$('a.topnav-logo, .store-logo a').focus();
			});

			if($('.survey-button.survey-button-js')) {
				$('.survey-button.survey-button-js').on('click', function (event) {
					var formId = $(event.target).data("formId");
	
					if(typeof formId !== "undefined" && window.KAMPYLE_ONSITE_SDK) {
						KAMPYLE_ONSITE_SDK.showForm(formId);
					}
				});
			}
		},
		
		unbindMobileEvents: function() {
			var self = this;
			self.$footerContent.off('click keydown');
		},

		bindMobileEvents: function(el) {
			var self = this;

			// Toogles accordion behavior in footer component
			self.$footerContent.on("click",function(){
				var $this = $(this),
					$columnHeader = $this.find(self.config.columnHeader),
					$columnContent = $this.find(self.config.columnContent),
					isCollapsed = $this.hasClass('collapsed');
					
				if (screenSize.size() === "small") {
					if ( isCollapsed ) {
						//open it
						$this.removeClass('collapsed');
						$columnContent.removeClass('hide').attr({'aria-hidden':'false'});
						$columnHeader.attr({'aria-expanded':'true'});
					} else {
						//close it
						$this.addClass('collapsed');
						$columnContent.addClass('hide').attr({'aria-hidden':'true'});
						$columnHeader.attr({'aria-expanded':'false'});
					}
				}
			});

			// Bind keyboard events to all items in the menu
			self.toggleKeyboardMenuEvents(self.$footerContent);
		},

		toggleKeyboardMenuEvents: function(el) {
			var self = this;
			el.off('keydown', self, self.keydownHandler);
			if(screenSize.size() === "small") {
				el.on('keydown', self, self.keydownHandler);
			}
		},

		/**
		* Handles keyboard events and dropdown elements
		* for user accessibility interactions
		* @param event JQuery Event
		**/
		keydownHandler: function(event) {
			var $col = $(this),
				$target = $(event.target),
				$heading = $col.find('.heading'),
				$links = $col.find('a'),
				keys = {
					down: 40,
					enter: 13,
					esc: 27,
					left: 37,
					right: 39,
					space: 32,
					tab: 9,
					up: 38
				};
			
			switch(event.keyCode) {

				// *** ENTER or SPACE ***
				// Toggle accordion open/closed
				case keys.space:
				case keys.enter:
					if($target.hasClass('heading')) {
						$col.click();
					}
				break;

				// *** DOWN ***
				// Move to next link in list. If on the last link, cycle back to the first link. If on the header, move to the fist link.
				case keys.down:
					if($target.hasClass('heading')) {
						event.preventDefault();
						$links.first().focus();
					}

					if($target.is('a')) {
						event.preventDefault();
						var $next = $target.parent().next().find('a');
						if(!$next.length) {
							$next = $links.first();
						}
						$next.focus();
					}
				break;


				// *** UP ***
				// Move to previous link in list. If on the first link, cycle back to the last link.
				case keys.up:
					if($target.is('a')) {
						event.preventDefault();
						var $prev = $target.parent().prev().find('a');
						if(!$prev.length) {
							$prev = $links.last();
						}
						$prev.focus();
					}
				break;


				// *** ESCAPE ***
				// Close accordion if opened
				case keys.esc:
					if(!$col.hasClass('collapsed')) {
						$heading.click().focus();
					}
				break;
			}
		},

		/**
		 * Expand all menus that are collapsed
		 **/
		_expandAllMenus : function(){
			var self = this;
			self.$footerContent.removeClass('collapsed');
			self.$columnContent.removeClass('hide').attr({'aria-hidden':null});
			self.$columnHeaders.attr({
				'aria-expanded' : null,
				'aria-haspopup' : null,
				'role' : null,
				'tabindex' : 'null'
			});
		},

		/**
		 * Collapse all menus that aren't collapsed
		 **/
		_collapseAllMenus : function(){
			var self = this;
			self.$footerContent.addClass('collapsed');
			self.$columnContent.addClass('hide').attr({'aria-hidden':'true'});
			self.$columnHeaders.attr({
				'aria-expanded':'false',
				'aria-haspopup':'true',
				'role': 'button',
				'tabindex' : '0'
			});
		},

		/**
		 * Loads the region selector template and initializes the dropdown
		 **/
		_loadRegionSelector : function() {
			var self = this;

			// preload the data to populate the dropdown list
			self.data = self.$regionSelectorButton.data('regions');

			// load the dropdown template on the first click
			self.$regionSelectorButton.one('click', function(e){
				self.loadAndCompileTemplate().done(function() {
					self._renderRegionSelector();
				});
			});
		},

		_renderRegionSelector : function() {
			var self = this;

			// append the compiled template
			self.$regionSelectorDropdown.html(self.compiledTemplate(self.data));

			// initialize foundation dropdown and open the menu
			new Foundation.Dropdown(self.$regionSelectorDropdown);
			self.$regionSelectorDropdown.foundation('open');
		}
	};

	footer.prototype = $.extend({}, HBCore, footer.prototype);
	footer.defaults = footer.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.footer = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new footer(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};


// START close Require.JS wrapper
	}
);
// END close Require.JS wrapper
